import { generateClient } from "aws-amplify/api";
import { listWorkflows } from "@/graphql/queries";
const client = generateClient();
export const ListAllWorkflows = {
  methods: {
    async GetAllWorkflowsMethod(workflow_status, workflow_type) {
      try {
        this.loading = true;
        let result = await client.graphql({
          query: listWorkflows,
          variables: {
            input: {
              user_id: this.$store.getters.get_current_user_details.user_id,
              workflow_status,
              workflow_type,
            },
          },
        });
        var ResultObj = JSON.parse(result.data.listWorkflows);
        this.loading = false;
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
          return ResultObj.data.items;
        } else {
          console.log("Error", ResultObj.message);
          return [];
        }
      } catch (error) {
        this.loading = false;
        console.log("Error", error);
        return [];
      }
    },
  },
};
